import moment from 'moment';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/zh-tw';
import 'moment/locale/zh-cn';

export function init(locale) {
  moment.locale(locale.toLowerCase());
}

export default {
  init,
};
